<template>
  <div class="chat-navbar" @mousedown="emitEvent" :class="{'mobile': mobile}">
    <span class="chat-title">{{$t('chat.chatTitle')}}</span>
    <div class="close-chat" @click="closeChat">
      <span>{{$t('chat.closeChat')}}</span>
      <span class="material-icons">clear</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orientation: Boolean,
    mobile: Boolean,
  },
  methods: {
    closeChat() {
      this.$emit("closechat");
    },
    emitEvent(e) {
      this.$emit("mousedown", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@mixin flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

$chat-height: 400px;
$chat-width: 600px;
$navbar-height: 40px;
$padding-width: 20px;

.chat-navbar {
  z-index: 40;
  user-select: none;
  padding: 0 $padding-width;
  @include flex-between();
  user-select: none;
  height: $navbar-height;
  touch-action: none;
  border-radius: 8px 8px 0 0;
  &.mobile {
    border-radius: 0;
    font-weight: 700;
    .chat-title {
      font-size: 25px;
    }
  }
}
.chat-title {
  font-size: 20px;
}

.close-chat {
  cursor: pointer;
  @include flex-end();
  span {
    color: #a8a8a8;
  }
  .material-icons {
    font-size: 17px;
    font-weight: 900;
    margin-left: 6px;
  }
}
</style>